/** Каталог якорей модуля «Задачи» */
export const TASKS_ANCHORS = {
  table: {
    create: 'tasks.table.create',
    search: 'tasks.table.search',
    filtersPanel: 'tasks.table.filtersPanel',
    role: 'tasks.table.role',
    source: 'tasks.table.source',
    quickFirst: 'tasks.table.quick.overdue',
    quickLast: 'tasks.table.quick.requiresAction',
    hideCompleted: 'tasks.table.hideCompleted',
    resetFilters: 'tasks.table.resetFilters',

    /** Префикс якоря заголовка колонки с фильтром, дальше — ключ колонки из `headers` */
    filterPrefix: 'tasks.table.filter.',
    filterFirst: 'tasks.table.filter.status',
    filterLast: 'tasks.table.filter.responsible_employee',
    demoRow: 'tasks.table.demoRow',
    demoRowMenu: 'tasks.table.demoRowMenu',
  },
} as const

export const TASKS_CONTEXTS = {
  table: 'tasks.table',
  card: 'tasks.card',
} as const
